const moment = require("moment");

export const bytesToSize = (bytes) => {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};
export const formatDate = (timestamp, withoutTime) => {
  if (!timestamp) return "";

  let d = new Date(parseInt(timestamp));
  if (withoutTime) {
    return d.toLocaleDateString();
  }
  return d.toLocaleDateString() + " " + d.toLocaleTimeString();
};
export const formatZData = (dateStringWithTime) => {
  const rawTimestamp = dateStringWithTime.replace(/T(\d+)-(\d+)-(\d+)\./, "T$1:$2:$3.");
  return moment(rawTimestamp).format("YYYY-MM-DD HH:mm:ss");
};

export const getFormatted = (input) => {
  if (input === null) return "";
  else if (typeof input == "string") {
    try {
      return JSON.stringify(JSON.parse(input), null, "\t");
    } catch (e) {
      return input;
    }
  } else if (typeof input == "object") return JSON.stringify(input, null, "\t");
  return input;
};
export const stringToInt = (text) => {
  const parsed = parseInt(text);
  if (isNaN(parsed)) {
    return 0;
  }
  return parsed;
};
